export enum DepositBonusInteractionContext {
	DepositBonusInteractionContext = "deposit-bonus-interaction-context",
}

export const enum DepositBonusAction {
	BonusSelectionOpen = "BonusSelectionOpen",
	BonusSelectionClick = "BonusSelectionClick",
}

export const enum KycAction {
	AccountVerificationOpen = "AccountVerificationOpen",
	AccountVerificationClick = "AccountVerificationClick",
}

export const enum OMSEvent {
	OMSClick = "OMSClick",
}

export const enum MyAccountEvent {
	MyAccountClick = "MyAccountClick",
}

export const enum GTMRealityCheckAction {
	Continue = "Reality Check - Click Continue",
	Logout = "Reality Check - Click Logout",
	Seen = "Reality Check - Seen",
	Hide = "Reality Check - Hide",
}

export const enum RealityCheckEvent {
	OverlayMessage = "OverlayMessage",
}

export const enum DepositLimitCalculatorEvent {
	Calculate = "DepositLimitCalculate",
	FieldChange = "DepositLimitCalculatorFieldChange",
	LinkClick = "DepositLimitCalculatorLinkClick",
}

export const enum GeofencingAlertEvent {
	GeofencingAlertSeen = "GeofencingAlertSeen",
}

export const enum GeofencingAlertItem {
	ContactSupport = "ContactSupport",
	Redirect = "Redirect",
}
